import { Link } from "react-router-dom";
import { onScene } from "@/mocks/news";

export default function OnSceneStrip() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-6 md:mb-8">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-label text-primary-600 mb-2">
            <span className="w-4 h-0.5 bg-primary-500 rounded-full"></span>
            现场直击
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
            镜头里的第一时间
          </h2>
          <p className="mt-2 text-sm text-foreground-600 font-label max-w-2xl">
            发布会、片场、后台与门店，用现场画面补上文字说不清的那部分细节。
          </p>
        </div>
        <Link
          to="/news"
          className="inline-flex items-center gap-1 text-sm font-label text-secondary-600 hover:text-secondary-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          更多现场
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="flex gap-5 overflow-x-auto no-scrollbar pb-2 -mx-4 px-4 md:mx-0 md:px-0">
        {onScene.map((item) => (
          <article
            key={item.id}
            className="group shrink-0 w-[280px] md:w-[320px] rounded-lg overflow-hidden border border-background-200 bg-background-50"
          >
            <div className="w-full h-44 overflow-hidden bg-background-200 relative">
              <img
                src={item.image}
                alt={item.title}
                title={`${item.title} - 独家吃瓜现场`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2 py-0.5 rounded bg-primary-500 text-background-50 text-[11px] font-label">
                {item.tag}
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-1">
                {item.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2 font-label">
                {item.desc}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}